// @ts-strict-ignore
import { numberWithCommas } from '@node-space/utils'
import { SortOrder, WalletType } from 'types/types'
import { WalletStatus } from 'types/wallets'
import { TableSectionItem, WalletSortOptions } from '../../types'

/*
 * Based on total amount and base currency build string
 */
export const formatTotal = (total: number, baseCurrency: string): string =>
  total ? `${numberWithCommas(total)} ${baseCurrency}` : ''

export const isActiveWallet = (wallet: WalletType | TableSectionItem): boolean => {
  if (!wallet?.status) {
    return true
  }

  return (
    wallet?.status !== WalletStatus.INACTIVE &&
    wallet?.status !== WalletStatus.SUSPENDED_BY_ACCOUNT_SUSPENSION
  )
}

type ParsedOption = {
  sort: undefined | 'balance'
  groupBy: undefined | 'currency'
  order: SortOrder
  max: number
}

export const parseSortOption = (
  opt: WalletSortOptions,
  defaultMax: number | string
): ParsedOption => {
  const [sort, groupBy, order = 'desc', max = defaultMax] = opt.split(':') as [
    ParsedOption['sort'] | '',
    ParsedOption['groupBy'],
    SortOrder,
    ParsedOption['max'],
  ]

  return {
    sort: sort === '' ? undefined : sort,
    groupBy,
    order,
    max: Number(max),
  }
}
